import { useCallback } from 'react';
import { Grid } from '@mui/material';

import { SelectionList } from '../../../../../common';
import { ASSESSMENT_BARRIER_OPTIONS } from '../constants';

import type { AssessmentBarriersSectionProps } from './types';

export default function AssessmentBarriersSection({
  barriers,
  disabled,
  isSaving,
  onUpdate,
}: AssessmentBarriersSectionProps) {
  const handleAdd = useCallback(
    (value: string) => onUpdate({ barriers: [...barriers, value] }),
    [barriers, onUpdate],
  );
  const handleDelete = useCallback(
    async (id: number) => {
      const value = barriers[id];
      if (value == null) return false;
      return onUpdate({ barriers: barriers.filter((item) => item !== value) });
    },
    [barriers, onUpdate],
  );

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <SelectionList
          addButtonLabel="Add barriers"
          disabled={disabled}
          entries={barriers.map((value, index) => ({ id: index, value }))}
          getDeleteConfirm={(entry) => ({
            title: 'Confirm barrier deletion?',
            message: `You are about to delete "${entry.value}"`,
          })}
          isSaving={isSaving}
          label="Barriers noted during the assessment"
          onAdd={handleAdd}
          onDelete={handleDelete}
          options={ASSESSMENT_BARRIER_OPTIONS}
          placeholder="Select barrier"
        />
      </Grid>
    </Grid>
  );
}
